import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	assetOwnerId: string | null;
	assetTypeId: string | null;
	assetSubTypeId: string | null;
	isAvailableInPeriod: boolean | null;
	fromDate: number | null;
	toDate: number | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	assetOwnerId: null,
	assetTypeId: null,
	assetSubTypeId: null,
	isAvailableInPeriod: null,
	fromDate: null,
	toDate: null,
};

const assetCartRequestFullView = createSlice({
	name: 'assetCartRequestFullView',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setAssetOwnerId: (state, action: PayloadAction<{ assetOwnerId: string | null }>) => {
			state.assetOwnerId = action.payload.assetOwnerId;
			state.page = initialState.page;
		},
		setAssetTypeId: (state, action: PayloadAction<{ assetTypeId: string | null }>) => {
			state.assetTypeId = action.payload.assetTypeId;
			state.page = initialState.page;
		},
		setAssetSubTypeId: (state, action: PayloadAction<{ assetSubTypeId: string | null }>) => {
			state.assetSubTypeId = action.payload.assetSubTypeId;
			state.page = initialState.page;
		},
		setIsAvailableInPeriod: (state, action: PayloadAction<{ isAvailableInPeriod: boolean | null }>) => {
			state.isAvailableInPeriod = action.payload.isAvailableInPeriod;
			state.page = initialState.page;
		},
		setFromDate: (
			state,
			action: PayloadAction<{ fromDate: number | null }>,
		) => {
			if (action.payload.fromDate) {
				state.fromDate = startOfDayInMilliseconds(action.payload.fromDate);
			} else state.fromDate = null;

			state.page = initialState.page;
		},
		setToDate: (
			state,
			action: PayloadAction<{ toDate: number | null }>,
		) => {
			if (action.payload.toDate) {
				state.toDate = startOfDayInMilliseconds(action.payload.toDate);
			} else state.toDate = null;

			state.page = initialState.page;
		},
		resetAssetCartRequestTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setAssetOwnerId,
	setAssetTypeId,
	setAssetSubTypeId,
	setIsAvailableInPeriod,
	setFromDate,
	setToDate,
} = assetCartRequestFullView.actions;

export default assetCartRequestFullView.reducer;
